export const isMetaDataCurrent = (prev, current) => ( // eslint-disable-line import/prefer-default-export
  (current.startDate)
    && (current.startDate === prev.startDate)
    && (current.endDate === prev.endDate)
    && (current.platform === prev.platform)
);
